// Pure Generated Target Vocab for Week 35
export const week35Vocab = [
  {
    "id": 1,
    "word": "lion",
    "definition_en": "A large wild cat known as the king of the jungle.",
    "definition_vi": "Sư tử, loài mèo lớn được mệnh danh là vua rừng xanh.",
    "example_en": "The mighty lion was sleeping under a shady tree.",
    "example_vi": "Chú sư tử dũng mãnh đang ngủ dưới bóng cây râm mát.",
    "audio_word": "/audio/week35/vocab_lion.mp3"
  },
  {
    "id": 2,
    "word": "mouse",
    "definition_en": "A tiny furry animal with a long tail.",
    "definition_vi": "Chú chuột nhỏ bé có đuôi dài và bộ lông mềm.",
    "example_en": "A tiny mouse ran across the forest path.",
    "example_vi": "Một chú chuột nhỏ chạy ngang qua lối đi trong rừng.",
    "audio_word": "/audio/week35/vocab_mouse.mp3"
  },
  {
    "id": 3,
    "word": "paw",
    "definition_en": "The foot of an animal that has claws.",
    "definition_vi": "Bàn chân có móng vuốt của động vật.",
    "example_en": "The mouse accidentally touched the lion's front paw.",
    "example_vi": "Chú chuột vô tình chạm vào bàn chân trước của sư tử.",
    "audio_word": "/audio/week35/vocab_paw.mp3"
  },
  {
    "id": 4,
    "word": "hunter",
    "definition_en": "A person who tracks and catches wild animals.",
    "definition_vi": "Thợ săn, người lần theo và bắt động vật hoang dã.",
    "example_en": "Two hunters set a trap in the woods.",
    "example_vi": "Hai người thợ săn đặt bẫy trong rừng.",
    "audio_word": "/audio/week35/vocab_hunter.mp3"
  },
  {
    "id": 5,
    "word": "net",
    "definition_en": "A strong trap made of twisted ropes.",
    "definition_vi": "Tấm lưới bẫy chắc chắn làm từ dây thừng.",
    "example_en": "The lion was caught in a heavy rope net.",
    "example_vi": "Sư tử bị mắc kẹt trong một tấm lưới thừng nặng.",
    "audio_word": "/audio/week35/vocab_net.mp3"
  },
  {
    "id": 6,
    "word": "rope",
    "definition_en": "Strong thick cord used for tying things.",
    "definition_vi": "Dây thừng chắc dày dùng để buộc đồ vật.",
    "example_en": "The brave mouse chewed through the thick rope.",
    "example_vi": "Chú chuột dũng cảm gặm đứt sợi dây thừng dày.",
    "audio_word": "/audio/week35/vocab_rope.mp3"
  },
  {
    "id": 7,
    "word": "trap",
    "definition_en": "A device used to catch animals.",
    "definition_vi": "Cái bẫy dùng để bắt động vật.",
    "example_en": "The lion stepped into a hidden trap.",
    "example_vi": "Sư tử bước vào một cái bẫy bị giấu kín.",
    "audio_word": "/audio/week35/vocab_trap.mp3"
  },
  {
    "id": 8,
    "word": "chew",
    "definition_en": "To bite something repeatedly with teeth.",
    "definition_vi": "Gặm hoặc nhai liên tục bằng răng.",
    "example_en": "The mouse began to chew the ropes quickly.",
    "example_vi": "Chú chuột bắt đầu gặm dây thừng thật nhanh.",
    "audio_word": "/audio/week35/vocab_chew.mp3"
  },
  {
    "id": 9,
    "word": "free",
    "definition_en": "To release from a cage, trap or danger.",
    "definition_vi": "Giải thoát khỏi lồng, bẫy hoặc nguy hiểm.",
    "example_en": "The little mouse set the big lion free.",
    "example_vi": "Chú chuột nhỏ đã giải thoát cho chú sư tử to lớn.",
    "audio_word": "/audio/week35/vocab_free.mp3"
  },
  {
    "id": 10,
    "word": "promise",
    "definition_en": "A statement that you will definitely do something.",
    "definition_vi": "Lời hứa chắc chắn sẽ làm điều gì đó.",
    "example_en": "The mouse kept his promise to help his friend.",
    "example_vi": "Chú chuột đã giữ đúng lời hứa giúp đỡ bạn mình.",
    "audio_word": "/audio/week35/vocab_promise.mp3"
  },
  {
    "id": 11,
    "word": "roar",
    "definition_en": "To make a very loud, deep sound.",
    "definition_vi": "Tiếng gầm lớn, trầm của sư tử hoặc thú dữ.",
    "example_en": "The trapped lion let out a loud roar.",
    "example_vi": "Chú sư tử bị mắc bẫy phát ra tiếng gầm thật to.",
    "audio_word": "/audio/week35/vocab_roar.mp3"
  },
  {
    "id": 12,
    "word": "forest",
    "definition_en": "A large area filled with many trees.",
    "definition_vi": "Khu rừng rộng lớn có nhiều cây cối.",
    "example_en": "They lived in a peaceful green forest.",
    "example_vi": "Họ sống trong một khu rừng xanh yên bình.",
    "audio_word": "/audio/week35/vocab_forest.mp3"
  },
  {
    "id": 13,
    "word": "claws",
    "definition_en": "Sharp curved nails on an animal's foot.",
    "definition_vi": "Móng vuốt sắc nhọn trên chân thú.",
    "example_en": "The lion opened his big sharp claws.",
    "example_vi": "Sư tử giương bộ móng vuốt to và sắc nhọn.",
    "audio_word": "/audio/week35/vocab_claws.mp3"
  },
  {
    "id": 14,
    "word": "sharp",
    "definition_en": "Having a thin edge or point that cuts easily.",
    "definition_vi": "Sắc bén, có cạnh mỏng hoặc đầu nhọn dễ cắt.",
    "example_en": "The mouse used his sharp front teeth.",
    "example_vi": "Chú chuột dùng những chiếc răng cửa sắc bén.",
    "audio_word": "/audio/week35/vocab_sharp.mp3"
  },
  {
    "id": 15,
    "word": "fable",
    "definition_en": "A short traditional story teaching a moral lesson.",
    "definition_vi": "Truyện ngụ ngôn ngắn dạy bài học đạo đức.",
    "example_en": "Aesop wrote many wonderful fables.",
    "example_vi": "Aesop đã viết nhiều câu chuyện ngụ ngôn tuyệt vời.",
    "audio_word": "/audio/week35/vocab_fable.mp3"
  },
  {
    "id": 16,
    "word": "cooperate",
    "definition_en": "To work together toward a shared goal.",
    "definition_vi": "Hợp tác, cùng làm việc hướng tới mục tiêu chung.",
    "example_en": "Animals cooperate to survive in the wild.",
    "example_vi": "Động vật hợp tác để sinh tồn trong tự nhiên.",
    "audio_word": "/audio/week35/vocab_cooperate.mp3"
  },
  {
    "id": 17,
    "word": "brave",
    "definition_en": "Showing courage and not being afraid.",
    "definition_vi": "Dũng cảm, can đảm và không sợ hãi.",
    "example_en": "The brave mouse rushed over to rescue the lion.",
    "example_vi": "Chú chuột dũng cảm lao tới để giải cứu sư tử.",
    "audio_word": "/audio/week35/vocab_brave.mp3"
  },
  {
    "id": 18,
    "word": "grateful",
    "definition_en": "Feeling thankful for someone's kindness.",
    "definition_vi": "Biết ơn, cảm kích vì lòng tốt của người khác.",
    "example_en": "The lion felt deeply grateful to his little helper.",
    "example_vi": "Sư tử cảm thấy vô cùng biết ơn người bạn nhỏ.",
    "audio_word": "/audio/week35/vocab_grateful.mp3"
  },
  {
    "id": 19,
    "word": "ecosystem",
    "definition_en": "A community of living organisms interacting together in nature.",
    "definition_vi": "Hệ sinh thái, tập hợp các sinh vật sống tương tác cùng nhau trong tự nhiên.",
    "example_en": "All creatures play an important role in the forest ecosystem.",
    "example_vi": "Mọi loài sinh vật đều đóng vai trò quan trọng trong hệ sinh thái rừng.",
    "audio_word": "/audio/week35/vocab_ecosystem.mp3"
  },
  {
    "id": 20,
    "word": "friendship",
    "definition_en": "The state of being mutual, caring friends.",
    "definition_vi": "Tình bạn, sự gắn bó thân thiết giữa bạn bè.",
    "example_en": "True friendship makes everyone stronger and happier.",
    "example_vi": "Tình bạn chân thành giúp mọi người mạnh mẽ và hạnh phúc hơn.",
    "audio_word": "/audio/week35/vocab_friendship.mp3"
  }
];

export const vocabList = week35Vocab;
export default week35Vocab;
